
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promo/[slug]",
      function () {
        return require("private-next-pages/promo/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promo/[slug]"])
      });
    }
  